import {
    Row,
    Col
} from "reactstrap";
// import { useNavigate } from "react-router-dom";

import { Spinner } from "react-bootstrap";

import { getOneUserTransactions } from "../services/transactionService";
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";
// import utils from "../../../utils/utils";
import FullLayout from '../layouts/FullLayout';
import { useNavigate, useParams,useLocation } from "react-router-dom";

// import Pagination from "../../../components/Pagination";
import Toast from 'react-bootstrap/Toast';
import { useState, useEffect, useContext } from "react";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
// import DeleteModal from "../../../components/DeleteModal";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


export default function Settings() {

    const [transaction, setTransaction] = useState([]);

    const [transactionError, settransactionError] = useState('')


    const [isEditable, setIsEditable] = useState(false);

    // const toast: any = useContext(ToastContext);
    const [show, setShow] = useState(false);
    const [successValue, setSuccessValue] = useState("");
    const [message, setMessage] = useState("")

    let { id } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    
    const { userId, userName } = location.state || {}; 
    const toast = useContext(AlertContext);
    useEffect(() => {
        // if (id) {
        fetchTransaction(id);
        // }
    }, [id]);

    const fetchTransaction = async (id) => {

        const response = await getOneUserTransactions(id);
        console.log('id..', id)
        console.log('response..', response)

        const responseData = response.data;
        let theme = "success"
        if (response.status == 200) {
            setTransaction(response.data.data || []);

        } else {
            theme = "danger"
        }
        window.scrollTo(0, 0);
        // toast.setToast(responseData?.data, theme);

    }
    console.log('transaction', transaction)
    return (
        <FullLayout
        >
            <Row>
                <div className="panel_top_section">
         
                   
                        <h2 className="text-center">Transactions for {userName}</h2>
                   
                </div>
                <Col>

                    {transaction.length > 0 ? (
                        transaction.map((item) =>
                            <div className={(item.mode === 'Sell' || item.mode === 'Withdraw') ? "trans_history3" : "trans_history"}>
                                <div className="transaction_container">
                                    <h4>CORSIA</h4>
                                    <p>{item.currency}</p>
                                </div>
                                <div className="transaction_container">
                                    <p className={(item.mode === 'Sell' || item.mode === 'Withdraw') ? "sell" : "buy"}
                                    >{item.mode}</p>
                                    <h4 className={(item.mode === 'Sell' || item.mode === 'Withdraw') ? "sell" : "buy"}>
                                        {(item.mode === 'Sell' || item.mode === 'Withdraw') ? `-${item.amount}` : `+${item.amount}`}
                                    </h4>

                                </div>
                            </div>
                        )) : (

                        <p className="text-center p-3">No Data Found</p>

                    )}

                </Col>
            </Row >

        </FullLayout>
    )
}